<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import EmptyLayout from "@/layouts/EmptyLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";

const route = useRoute();

const layoutComponent = computed(() => {
  return route.meta.layout === "empty" ? EmptyLayout : MainLayout;
});
</script>

<style lang="css">
@import "assets/reset.css";
@import "assets/index.css";
@import "assets/grid.css";
@import "assets/fonts.css";
@import "assets/loader.css";
@import "assets/form.css";
@import "assets/media.css";
</style>

<style lang="scss">
@import "assets/controls.scss";
</style>